import { Common, ApiBind } from './common.model';
import { PlacementAsset } from './placement-asset.model';

export class PlacementAssets extends Common {
  @ApiBind({ column: 'assets', model: (value) => value.map(v => new PlacementAsset(v)) })
  assets: PlacementAsset[];

  @ApiBind({ column: 'placement_id' })
  placementId: number;
}
